export default "__VITE_PUBLIC_ASSET__82515637__"